import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API, { mapApiUrl as MapQK } from './api';
import { ResponseType } from 'src/constants/data';
import { BusinessMapParams } from '../types';

export const useGetMap = (params: BusinessMapParams) => {
  return useQuery({
    queryKey: [MapQK, ResponseType.List, params],
    queryFn: () => API.getBusinessMap(params),
    placeholderData: keepPreviousData
  });
};

export const useGetRegions = () => {
  return useQuery({
    queryKey: [MapQK, ResponseType.List],
    queryFn: () => API.getRegions(),
    placeholderData: keepPreviousData
  });
};

export const useGetCategories = () => {
  return useQuery({
    queryKey: [MapQK, ResponseType.List],
    queryFn: () => API.getCategories(),
    placeholderData: keepPreviousData
  });
};
